module.exports = __webpack_public_path__ + "img/logo.47c426dd.png";